import routerOptions0 from "/home/runner/work/delight.ai/delight.ai/frontend/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/home/runner/work/delight.ai/delight.ai/frontend/app/router.options.ts";
const configRouterOptions = {
  strict: false,
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}